import { PBox } from "../../theme/BaseTheme";
import { FeatureImageLeft } from "../../sections/FeatureImageLeft";
import { FeatureImageRight } from "../../sections/FeatureImageRight";
import { SellFaq } from "../../sections/SellFaq";
import UseCases from "../../sections/UseCases";

const rococo_filter_faq_data = [
    {
        question: "What is the Rococo Filter, and how does it work?",
        answer: "The Rococo Filter transforms your photos into elegant artworks inspired by 18th-century European Rococo paintings. It enhances images with soft pastel palettes, golden highlights, delicate brush textures, and ornamental lighting for a dreamy, romantic finish.",
    },
    {
        question: "Do I need artistic experience to use the Rococo Filter?",
        answer: "Not at all. Simply upload your photo — the AI handles the rest, automatically applying the Rococo color tones, lighting, and painterly effects for you.",
    },
    {
        question: "What kinds of photos work best with the Rococo Filter?",
        answer: "Portraits and fashion photos work beautifully with this style, but it also complements interiors, floral scenes, and romantic settings. The filter adds an aristocratic, vintage charm to any photo.",
    },
    {
        question: "Are my images safe and private?",
        answer: "Yes. All uploads are securely processed and automatically deleted after generation to protect your privacy and data.",
    },
];

const rococo_filter_use_cases = [
    {
        image: "/images/image-filters/rococo-filter-5.webp",
        title: "Romantic Portraits",
        description:
            "Transform ordinary portraits into ethereal Rococo masterpieces — perfect for profile pictures, couple photos, or styled fashion shoots. The filter adds pastel tones, soft glow, and a painterly finish reminiscent of 18th-century art.",
    },
    {
        image: "/images/image-filters/rococo-filter-6.webp",
        title: "Elegant Art Prints",
        description:
            "Use the Rococo Filter to create decorative artwork for walls, gifts, or posters. The aesthetic’s charm and delicacy make it ideal for personalized home decor or boutique displays.",
    },
    {
        image: "/images/image-filters/rococo-filter-7.webp",
        title: "Fashion & Editorial Design",
        description:
            "Enhance lookbooks, brand campaigns, or creative shoots with Rococo-inspired visuals. The filter adds a graceful, high-art aesthetic that blends historical elegance with modern photography.",
    },
];

const RococoFilter = () => {
    return (
        <PBox>
            <FeatureImageLeft
                image={"/images/image-filters/rococo-filter-1.webp"}
                title={"Transform Photos into Rococo Masterpieces"}
                description={
                    "Reimagine your photos in the romantic elegance of the Rococo era. The AI applies delicate brushstrokes, ornamental glow, and pastel hues to create art that feels both royal and dreamlike."
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/rococo-filter-2.webp"}
                title={"Capture the Grace and Luxury of the 18th Century"}
                description={
                    "The Rococo Filter enhances fine details, highlights golden tones, and softens contrasts — evoking the lightness and charm of European aristocratic portraits and interiors."
                }
            />
            <FeatureImageLeft
                image={"/images/image-filters/rococo-filter-3.webp"}
                title={"Perfectly Balanced Pastel Palette"}
                description={
                    "From rose pinks and sky blues to ivory and gold, the Rococo Filter harmonizes every shade. It brings a refined, romantic atmosphere to any image, echoing the colors of classic palace art."
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/rococo-filter-4.webp"}
                title={"For Artists, Creators, and Aesthetic Lovers"}
                description={
                    "Ideal for creators who love elegance and sophistication, this filter helps turn modern photos into timeless digital paintings worthy of Versailles walls."
                }
            />
            <UseCases
                data={rococo_filter_use_cases}
                title={"Creative and Pretty Rococo Filters for Everyone"}
            />
            <SellFaq data={rococo_filter_faq_data} />
        </PBox>
    );
};

export default RococoFilter;
